<template> 
    <modal
      name="downloadDesktopAppModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="600px"
      height="auto"
    >
      <div class="v-modal profile_details_modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">e-File</h2>
          <span @click="hideMe()">
            <em class="material-icons">close</em>
          </span>
        </div>
  
        <form @submit.prevent data-vv-scope="changeCaseTypeForm"  @keydown.enter.prevent>
          <div class="form-container padb20">
            <h6 class="popup-title">Download and install the Immibox desktop application to e-File the case.</h6>
          </div>
          <div class="popup-footer relative">
            <span class="loader" v-if="caseTypeCahnging"
              ><img src="@/assets/images/main/loader.gif"
            /></span>
  
            <vs-button
              color="dark"
              @click="hideMe()"
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >
            <vs-button
              color="success"
              @click="submitForm()"
              class="save"
              type="filled"
              >Download
            </vs-button>
          </div>
        </form>
      </div>
    </modal>
  </template>
  <script>
  export default {
    methods: {
      submitForm() {
        const url = 'https://immibox.com/desktop/immibox.exe';
      window.open(url, '_blank');
      this.$modal.hide("downloadDesktopAppModal");
      this.$emit("hideMe");
      },
      hideMe() {
        this.$modal.hide("downloadDesktopAppModal");
        this.$emit("updatepetition");
        this.$emit("hideMe");
      },
      
    },
    mounted() {
      this.$modal.show("downloadDesktopAppModal");
  
    },
    data: () => ({
      caseTypeCahnging: false,
      formerrors: {
        msg: "",
      },
      selectedAssignedUsers: [],
      selectedCaseSubType: null,
      visasubtypes: [],
    }),
    props: {
      petitionDetails: {
        type: Object,
        default: null,
      },
      currentCaseSubType: {
        type: Object,
        default: null,
      },
      selectedCaseType: {
        type: Object,
        default: null,
      },
      assignedUsersList: {
        type: Array,
        default: null,
      },
      visatypes: {
        type: Array,
        default: null,
      },
    },
  };
  </script>